module.exports = __webpack_public_path__ + "static/how-to-get-rich-cf7608eb5c4e37751c1e27aa7f0c9dfe.jpg";